import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Integrations = () => {
    return (
        <div className="teboil-integration">
            <FullWrapper>
                <div className="teboil-integrationWrapper">
                    <div className="teboil-integrationTitle">Интеграция с внешними сервисами</div>
                    <div className="teboil-integrationList">
                        <div>
                            Для полноценного функционирования интернет-магазина shop.teboil.ru
                            интегрировали его с&nbsp;внешними сервисами. Подключили эквайринг
                            для&nbsp;оплаты товаров, справочник адресов для&nbsp;корректного
                            оформления доставки и фулфилмент-оператора для&nbsp;учета товаров,
                            отслеживания заказов и&nbsp;контроля других бизнес-процессов.
                        </div>
                        <div>
                            Фулфилмент&nbsp;&mdash; важнейший узел, обеспечивающий процесс
                            взаимодействия интернет&ndash;магазина с покупателями. Для
                            интернет&ndash;магазина Teboil спроектировалии и настроили интеграцию
                            с&nbsp;филфилмент-оператором, которого выбрал заказчик. Этот сервис
                            автоматизирует все&nbsp;процессы по&nbsp;клиентским заказам
                            и&nbsp;содержит данные о товарных остатках на&nbsp;складе,
                            синхронизирует статусы заказов с&nbsp;сайтом, рассчитывает тарифы
                            и&nbsp;способы доставки, аккумулирует запросы на&nbsp;отмену заказов.
                        </div>
                        <div>
                            Сервис интернет-оплаты интегрировали через&nbsp;API. Одно из
                            преимуществ&nbsp;&mdash; компания самостоятельно сможет отслеживать
                            финансовый поток по&nbsp;заказам, и&nbsp;если с оплатой возникнет
                            какая-то проблема, компания сможет разобраться во всём самостоятельно
                            и&nbsp;оперативно, не&nbsp;отправляя клиента в банк.
                        </div>
                        <div>
                            Для удобства покупателей по вводу информации, проверке и автозаполнению
                            адресов подключили справочник Dadata. Он определяет города и адреса с
                            почтовыми индексами&nbsp;по IP-адресу пользователя для корректного
                            формирования заказов.
                        </div>
                        <div>
                            <img
                                src="/images/pic/teboil/integrationScheme.jpg"
                                alt="intScheme"
                                className="teboil-integrationImage"
                            ></img>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Integrations;
